export const API_URL = 'https://carrentaladminapi.appgrowthcompany.com/admin/';

export const END_POINTS = {
  login: 'user/login',
  forgotPassword: 'user/forgotPassword',
  verifyOtp: 'user/verifyOtp',
  resetPassword: 'user/resetPassword',
  changePassword: 'user/changePassword',
  getProfile: 'user/getProfile',
  updateProfile: 'user/updateProfile',
  logout: 'user/logout',

  // store
  getStore: 'user/getStores',
  deleteStore: 'user/deleteStore',
  getStoreById: 'user/getStoreById',
  updateStore: 'user/updateStore',

  // masterData
  getMasterData: 'common/getMasterData',

  // graph
  getGraphsData: 'user/analytics',
  getChangeGraphsData: 'user/changeGraphStatus',

  // users
  users: 'user/getUsers',
  editUser: 'user/editUser',
  deleteUser: 'user/deleteUser',
  getUsersById: 'user/getUsersById',

  // vehicleType
  vehicleType: 'vehicle/addVehicle',
  updateVehicle: 'vehicle/updateVehicle',
  getVehicleTypes: 'vehicle/getVehicle',
  getVehicleById: 'vehicle/getVehicleById',
  deleteVehicleType: 'vehicle/deleteVehicle',

  //cms
  cms: 'cms',
  faqList: 'cms/listFaqs',
  faq: 'cms/faqs',

  //blogs
  addBlog: 'blog/addBlog',
  updateBlog: 'blog/updateBlog',
  getBlog: 'blog/getBlog',
  getBlogById: 'blog/getBlogById',
  deleteBlog: 'blog/deleteBlog',

  // brands
  addBrand: 'brand/addBrand',
  updateBrand: 'brand/updateBrand',
  getBrands: 'brand/getBrand',
  getBrandById: 'brand/getBrandById',
  deleteBrand: 'brand/deleteBrand',

  // features
  addFeature: 'feature/addFeature',
  updateFeature: 'feature/updateFeature',
  getFeatures: 'feature/getFeature',
  getFeatureById: 'feature/getFeatureById',
  deleteFeature: 'feature/deleteFeature',

  // equipments
  addEquipment: 'equipment/addEquipment',
  updateEquipment: 'equipment/updateEquipment',
  getEquipment: 'equipment/getEquipment',
  getEquipmentById: 'equipment/getEquipmentById',
  deleteEquipment: 'equipment/deleteEquipment',

  // loanYearRequests
  addLoanYearAndIntrestRate: 'loanYearsAndIntrestRate',
  updateLoanYearAndIntrestRate: 'loanYearsAndIntrestRate',
  getLoanYearAndIntrestRate: 'loanYearsAndIntrestRate',
  getLoanYearAndIntrestRateById: 'loanYearsAndIntrestRate',
  deleteLoanYearAndIntrestRate: 'loanYearsAndIntrestRate',

  // loanRequests
  loanRequests: 'loanRequests',
  updateLoanRequest: 'loanrequests',

  //driveType
  addDriveSystem: 'driveSystem/addDriveSystem',
  updateDriveSystem: 'driveSystem/updateDriveSystem',
  getDriveSystem: 'driveSystem/getDriveSystem',
  getDriveSystemById: 'driveSystem/getDriveSystemById',
  deleteDriveSystem: 'driveSystem/deletedriveSystem',

  //bodyType
  addBodyType: 'bodyType/addBodyType',
  updateBodyType: 'bodyType/updateBodyType',
  getBodyType: 'bodyType/getBodyType',
  getBodyTypeById: 'bodyType/getBodyTypeById',
  deleteBodyType: 'bodyType/deleteBodyType',

  // colors
  addColor: 'color/addColor',
  updateColor: 'color/updateColor',
  getColors: 'color/getColor',
  getColorById: 'color/getColorById',
  deleteColor: 'color/deleteColor',

  // gcc
  addGcc: 'gcc/addGcc',
  updateGcc: 'gcc/updateGcc',
  getGcc: 'gcc/getGcc',
  getGccById: 'gcc/getGccById',
  deleteGcc: 'gcc/deleteGcc',

  // vehicleModel
  addVehicleModel: 'vehicleModel/addVehicleModel',
  updateVehicleModel: 'vehicleModel/updateVehicleModel',
  getVehicleModel: 'vehicleModel/getVehicleModel',
  getVehicleModelById: 'vehicleModel/getVehicleModelById',
  deleteVehicleModel: 'vehicleModel/deleteVehicleModel',

  // vehicleModel
  addTrim: 'trim/addTrim',
  updateTrim: 'trim/updateTrim',
  getTrim: 'trim/getTrim',
  getTrimById: 'trim/getTrimById',
  deleteTrim: 'trim/deleteTrim',

  // Power
  addHorsePower: 'horsePower/addHorsePower',
  updateHorsePower: 'horsePower/updateHorsePower',
  getHorsePower: 'horsePower/getHorsePower',
  getHorsePowerById: 'horsePower/getHorsePowerById',
  deleteHorsePower: 'horsePower/deleteHorsePower',

  // damage
  addDamage: 'damage/addDamage',
  updateDamage: 'damage/updateDamage',
  getDamage: 'damage/getDamage',
  getDamageById: 'damage/getDamageById',
  deleteDamage: 'damage/deleteDamage',

  // Fuel Type
  addFuelType: 'fuelType/addFuelType',
  updateFuelType: 'fuelType/updateFuelType',
  getFuelType: 'fuelType/getFuelType',
  getFuelTypeById: 'fuelType/getFuelTypeById',
  deleteFuelType: 'fuelType/deleteFuelType',

  // Engine Capacity
  addEngineCapacity: 'engineCapacity/addEngineCapacity',
  updateEngineCapacity: 'engineCapacity/updateEngineCapacity',
  getEngineCapacity: 'engineCapacity/getEngineCapacity',
  getEngineCapacityById: 'engineCapacity/getEngineCapacityById',
  deleteEngineCapacity: 'engineCapacity/deleteEngineCapacity',

  // listings
  getListing: 'user/getAddListing',
  getListingById: 'user/getAddsById',
  updateListing: 'user/updateAddStatus',
  deleteListing: 'addVehicleAdds/deleteAdds',
  addListing: 'addVehicleAdds/createAdds',
  updateListingDetails: 'addVehicleAdds/updateAdds',
  getAddListing: 'user/getAddListing',
  getUserRating: 'user/getUserRating',

  //rating
  rating: '/rating/getRatingAdminSide',
  ratingUpdate: '/rating/updateRatingAdminSide',
  ratingDelete: '/rating/deleteRating',

  //dashboard
  dashboard: 'dashboard/dashboardAdmin',

  //banner
  addBanner: 'banner/addBanner',
  getBanner: 'banner/getBanner',
  deleteBanner: 'banner/deleteBanner',
  updateBanner: 'banner/updateBanner',
  getBannerById: 'banner/getBannerById',

  //subAdmin & Roles
  subadminaccess: 'subadminaccess',
  getSubAdmin: 'subadminaccess/list',
  subadmin: '/user/subadmin',
  getsubAdmins: '/user/subadmins',

  // promocode
  addPromoCode: 'promocode/addPromocode',
  getPromoCode: 'promocode/getPromocode',
  updatePromoCode: 'promocode/updatePromocode',
  getPromoCodeById: 'promocode/getPromocodeById',
  deletePromoCode: 'promocode/deletePromocode',
  DealerDropdownForPromo: 'common/getDealerDropdownForPromo',

  //notification
  receivedNotification: 'notification',
  receivedNotificationDeleteById: 'notification',
  receivedNotificationDeleteAll: 'notification/allNotificationDeleted',
  notification: 'notification/broadCastNotification',
  getNotification: 'notification/globalNotification',

  // packages
  addPackage: 'subscription',
  updatePackage: 'subscription',
  getPackage: 'subscription/list',
  getPackageById: 'subscription',
  deletePackage: 'subscription',

  //Inspection
  inspection: '/inspection/getUserInspection',
  getInspectionById: '/inspection/getUserInspectionById',
  uploadReport: '/inspection/uploadInspectionReport',

  //CustomerSupport
  customerSupport: '/customerSupport/replySupport',
  getCustomerSupport: '/customerSupport/getQueries',

  //setting
  setting: 'setting',
  newsletter: 'newsLetter/subscribedUsers',
};
